import { Component, Input, Output, OnInit, EventEmitter } from "@angular/core";

@Component({
    selector: "finalizing-modal",
    template: `
        <div class="mod mod-modal" [class.is-open]="isVisible">
            <div class="mod-modal__dialog mod-modal__dialog--small">
                <div class="mod-modal__content">
                    <div
                        style="background: white; height: 20px; color: black; display: table"
                    >
                        <p class="leader">
                            Die Beratungsdokumentation wird gerade finalisiert.
                        </p>
                        <p>
                            Bitte haben Sie einen Moment Geduld, bis der Vorgang
                            abgeschlossen ist. Im Anschluss können Sie die
                            unterschriebene Version als PDF-Dokument
                            abspeichern.
                        </p>
                        <div class="waiting">
                            <span class="icon-loop spinning"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
    styleUrls: ["./zurich-style.css", "./zurich.css", "./main.css"],
    styles: [
        `
            .leader {
                font-weight: bold;
            }

            .waiting {
                padding-top: 0.3em;
                text-align: center;
                font-size: 250%;
            }
        `,
    ],
})
export class FinalizingModal {
    isVisible = false;

    public open(): void {
        this.isVisible = true;
    }

    public close(): void {
        this.isVisible = false;
    }
}
